import { platformClient } from './platform.client';
import { LoginResponse, Permissions, User } from '../types';

export interface UpdateProfileRequest {
  name?: string;
  phone?: string;
  timezone?: string;
  avatar_url?: string;
  ui_language?: string;
}

export interface SwitchMembershipRequest {
  membership_key: string;
}

export const getCurrentUser = async (): Promise<{ user: User; permissions: Permissions }> => {
  const response = await platformClient.get<{ user: User; permissions: Permissions }>('/me');
  return response.data;
};

export const updateProfile = async (
  data: UpdateProfileRequest
): Promise<{ user: User; permissions: Permissions }> => {
  const response = await platformClient.patch<{ user: User; permissions: Permissions }>('/me', data);
  return response.data;
};

export const uploadAvatar = async (file: File): Promise<{ avatar_url: string }> => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await platformClient.post<{ avatar_url: string }>('/me/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const removeAvatar = async (): Promise<{ success: boolean; avatar_url: null }> => {
  const response = await platformClient.delete<{ success: boolean; avatar_url: null }>('/me/avatar');
  return response.data;
};

export const switchMembership = async (
  data: SwitchMembershipRequest
): Promise<LoginResponse> => {
  const response = await platformClient.post<LoginResponse>('/me/switch-membership', data);
  return response.data;
};

